const Get_Price_Debounce = interactive_debounce(Request_Price, 1000)
const add_button = document.getElementById("add-button")

if (add_button != undefined){
  add_button.addEventListener("click", Handle_Submit_Click)
}

Load_Product_Options()  


let Latest_Price_ID = ""

function Handle_Submit_Click() {
    let AddButton = document.getElementById("add-button");
    AddButton.disabled = true;

    let PriceDisplay = document.getElementById("live-price");

    Validate(false)
    let mainform = document.querySelector("product-form form")

    if (mainform.reportValidity()) {
        document.getElementById("loading-screen").classList.remove("hidden")
        Disable_Events()

        PriceDisplay.innerHTML = "Adding to Cart"

        let urlSearch = new URLSearchParams(window.location.search);
        if (urlSearch.get("mode") == "swap") {
            //swap mode
            let old_var_id = urlSearch.get("id");
            Remove_Product(old_var_id)
            CreateProduct()

        } else {
            //all other modes
            CreateProduct()

        }


    }

    AddButton.disabled = false;


}


function Load_Product_Options() {
    let urlSearch = new URLSearchParams(window.location.search);
    let variant_id = urlSearch.get("id");
    let mode = urlSearch.get("mode");
    let AddButton = document.getElementById("add-button")
    let AddText = "Add"

    if (mode == "swap") {
        AddText = "Save"
        if (AddButton != undefined){
          AddButton.innerHTML = AddText
        }

        let qtn = urlSearch.get("qtn")
        let quanity_elem = document.querySelector("[name='quantity']")

        //update element quantity
        if (qtn != undefined) {
            quanity_elem.value = qtn
        }


    }
    if (AddButton != undefined){
      AddButton.setAttribute("data-okay-text", AddText)
    }
  
    if (variant_id == undefined || variant_id == null) {
        let first_cart_item = document.querySelector("cart-items tr.cart-item")

        if (first_cart_item != undefined) {
            variant_id = first_cart_item.getAttribute("data-variant-id")
        }
    }

    if (variant_id != undefined && variant_id != null) {
        Get_Product_Load_Options(variant_id, urlSearch.get("load") == "full")
    }

    for (elem of document.querySelector(".product-info__block product-form").querySelectorAll("select, input")) {
        elem.dispatchEvent(new Event('change'))
    }

    Validate()
    Get_Price()

}

function Get_Product_Load_Options(variant_id, is_full_load) {
    let urlTarget = "https://mke-cabinetry.anvil.app/_/api/load_product/" + String(variant_id)

    fetch(urlTarget, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',

        }
    })
        .then(response => response.json())
        .then(data => {
            console.log(data)
            product_form = document.querySelector(".product-info__block product-form")
            let update_elements = product_form.querySelectorAll("select, input")

            for (elem of update_elements) {
                let key = elem.getAttribute("name")

                if (elem != undefined && data.hasOwnProperty(key) && (elem.classList.contains("always-load") || is_full_load)) {
                    let value = data[key];
                    switch (elem.tagName) {
                        case "INPUT":
                            switch (elem.getAttribute("type")) {
                                case "text":
                                    elem.value = value;
                                    elem.dispatchEvent(new Event('change'))

                                case "hidden":
                                    let radio_elem = elem.parentElement.querySelector(`.input-radio-group input[value='${value}']`)
                                    if (radio_elem != undefined) {
                                        radio_elem.checked = true
                                        radio_elem.dispatchEvent(new Event('change'))
                                    }

                            }

                        case "SELECT":
                            let option = elem.querySelector(`[value='${value}']`)
                            if (option != undefined) {
                                elem.selectedIndex = option.index
                                elem.dispatchEvent(new Event('change'))
                            }


                    }
                }

            }



        })
        .catch((error) => {
            console.error('Error:', error);
        });

}

function Remove_Product(old_part_id) {
    let updates = {};
    updates[old_part_id] = 0;

    fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ updates })
    })
}





function Get_Price(UIActive = true) {

    if (UIActive) {
        live_price_elem = document.getElementById("live-price");

        if (live_price_elem != undefined){
          live_price_elem.innerHTML = "Calculating";
          
        }
        
        //document.getElementById("add-button").disabled = true;    
    }

    Get_Price_Debounce()

}

function interactive_debounce(callback, delay) {
    let timer
    return function () {
        clearTimeout(timer)
        timer = setTimeout(() => {
            callback();
        }, delay)
    }
}


function Build_Form_Data() {

    let input_elements = document.querySelectorAll('[data-used-in-pricing]');

    let product_id_input = document.querySelector('input[name="id"]')
    let formData = {
        'id': product_id_input.value,
        'request_id': Latest_Price_ID
    }


    for (let elem of input_elements) {
        //console.log(elem)      

        if (elem.nodeName == "SELECT" && !elem.classList.contains("hidden") && !elem.options[elem.selectedIndex].classList.contains("hidden") && !elem.parentElement.classList.contains("hidden")) {
            let processed_value = elem.options[elem.selectedIndex].value
            if (typeof processed_value == 'string') {
                processed_value = processed_value.replace("Laminate (Routed Doors)", "Laminate") //special specific cleaner
                formData[elem.name] = processed_value
            }
            formData[elem.name] = processed_value
            if (elem.options[elem.selectedIndex].hasAttribute("data-extra-product-info")) {
                formData[elem.name + "_extra_info"] = elem.options[elem.selectedIndex].getAttribute("data-extra-product-info")
            }
        }
        else if (elem.nodeName == "INPUT" && !elem.classList.contains("hidden") && !elem.parentElement.classList.contains("hidden")) {
            if (elem.classList.contains("fraction-enabled")) {
                formData[elem.name] = Convert_Fractional_Input(elem.value);
            } else {
                formData[elem.name] = elem.value
            }
            if (elem.hasAttribute("data-extra-product-info")) {
                formData[elem.name + "_extra_info"] = elem.getAttribute("data-extra-product-info")
            }
        }
    }

    return formData
}

function Build_Visualizer_Form_Data() {

    let input_elements = document.querySelectorAll('[data-used-in-pricing]');

    let product_id_input = document.querySelector('input[name="id"]')
    let formData = {
        'id': product_id_input.value
    }


    for (let elem of input_elements) {
        //console.log(elem)      

        if (elem.nodeName == "SELECT" && !elem.classList.contains("hidden") && !elem.options[elem.selectedIndex].classList.contains("hidden") && !elem.parentElement.classList.contains("hidden")) {
            let processed_value = elem.options[elem.selectedIndex].value
            if (typeof processed_value == 'string') {
                processed_value = processed_value.replace("Laminate (Routed Doors)", "Laminate") //special specific cleaner
                formData[elem.name] = processed_value
            }
            formData[elem.name] = processed_value
            if (elem.options[elem.selectedIndex].hasAttribute("data-extra-product-info")) {
                formData[elem.name + "_extra_info"] = elem.options[elem.selectedIndex].getAttribute("data-extra-product-info")
            }
            if (elem.options[elem.selectedIndex].hasAttribute("data-color")){
                formData[elem.name + "_color"] = elem.options[elem.selectedIndex].getAttribute("data-color")
            }

        }
        else if (elem.nodeName == "INPUT" && !elem.classList.contains("hidden") && !elem.parentElement.classList.contains("hidden")) {
            if (elem.classList.contains("fraction-enabled")) {
                formData[elem.name] = Convert_Fractional_Input(elem.value);
            } else {
                formData[elem.name] = elem.value
            }
            if (elem.hasAttribute("data-extra-product-info")) {
                formData[elem.name + "_extra_info"] = elem.getAttribute("data-extra-product-info")
            }
        }
    }

    return formData
}

function Request_Price() {

    live_price_elem = document.getElementById("live-price")
    add_elem = document.getElementById("add-button")

    //add_elem.disabled = true;

    const form = document.querySelector('form.js-product-form-main')


    if (form.checkValidity()) {
        let urlTarget = "https://mke-cabinetry.anvil.app/_/api/price"

        // create pricing_id update
        Latest_Price_ID = Math.random()
        let formData = JSON.stringify(Build_Form_Data())
        
        let visualizationData = JSON.stringify(Build_Visualizer_Form_Data())
        
        document.dispatchEvent(new CustomEvent("on:Product_Form_Change", { detail: {
            form: visualizationData,
        }}))

        fetch(urlTarget, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',

            },
            body: formData
        })
            .then(response => response.json())
            .then(answer => {
                console.log(answer)
                if (Latest_Price_ID != answer["request_id"]) {
                    return
                }

                add_elem.innerHTML = add_elem.getAttribute('data-okay-text');
                if (!answer["errors"]) {
                    price = answer['formatted_price'];
                    live_price_elem.innerHTML = String(price);
                    add_elem.removeAttribute("disabled")

                } else {
                    //errors
                    live_price_elem.innerHTML = "Invalid Selection";
                    add_elem.setAttribute("disabled", "")
                }

            })
            .catch((error) => {
                console.error('Error:', error);
                if (live_price_elem != undefined){
                  live_price_elem.innerHTML = "Invalid Selection";
                }
                if (add_elem != undefined){
                  add_elem.setAttribute("disabled", "")
                }
                
                
            });

    }
    else {
        live_price_elem.innerHTML = "Review Selections";
        add_elem.innerHTML = "Check"
        add_elem.removeAttribute("disabled")
    }




}

function CreateProduct() {
    let urlTarget = "https://mke-cabinetry.anvil.app/_/api/product_submit";
    let formData = Build_Form_Data();

    fetch(urlTarget, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',

        },
        body: JSON.stringify(formData)
    })
        .then(response => response.json())
        .then(answer => {
            console.log("ADD PRODUCT")
            console.log(answer)


            if (!answer["errors"]) {
                AddProduct(answer['custom_variant_id'], answer['properties'])
                Enable_Events()

            } else {
                //errors
                document.getElementById("loading-screen").classList.add("hidden")
                Enable_Events()

            }

        })
        .catch((error) => {
            console.error('Error:', error);
            document.getElementById("loading-screen").classList.add("hidden")
            Enable_Events()
        });

}

function AddProduct(add_variant_id, properties) {
    properties["_Add_ID"] = Date.now();
    let quanityElement = document.querySelector('input.qty-input__input')
    let formData = {
        'items': [{
            'id': add_variant_id,
            'quantity': quanityElement.value,
            "properties": properties
        }]
    };

    let urlTarget = window.Shopify.routes.root + 'cart/add.js'
    fetch(urlTarget, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(response => {
            if (response.ok) {
                let answer = response.json();

                if (!answer["errors"]) {
                    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }))
                    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { bubbles: true }))
                    document.addEventListener('on:cart-drawer:after-close', (event) => {
                        window.location.href = document.getElementById("add-button").getAttribute("data-redirect")
                    });
                    document.getElementById("loading-screen").classList.add("hidden")


                } else {
                    console.error('Error:', error);
                    document.getElementById("loading-screen").classList.add("hidden")
                    alert(error);
                }
                return answer;
            } else{
                setTimeout(() => {
                    AddProduct(add_variant_id, properties)
                }, 5000);
            }


        });
}

function Validate(UIActive = true) {

    Calculate_Form_Fields()

    const ShowWhenComponents = document.querySelectorAll('[data-val-show]');
    //data-val-show="target=value1,value2;"
    for (let component of ShowWhenComponents) {
        let Checklist = GetValidationTargets(component.getAttribute('data-val-show'));

        component.classList.add("hidden") //hide until validated to be okay

        for (let CheckKey of Object.keys(Checklist)) {
            CheckElements = document.querySelectorAll('[data-val-key="' + CheckKey + '"]')

            for (element of CheckElements) {
                if (element.getAttribute("type") == "radio" && element.checked) {
                    if (Checklist[CheckKey].includes(element.getAttribute('value'))) {
                        if (component.classList.contains("hidden")) {
                            component.classList.remove("hidden");
                        }
                    }
                }

            }

            InputElements = document.querySelectorAll('[name="properties[' + CheckKey + ']"]')
            for (element of InputElements) {
                if ((element.getAttribute("type") == "text") || (element.getAttribute("type") == "hidden")) {
                    let elem_value = 0
                    if (element.classList.contains("fraction-enabled")) {
                        elem_value = Convert_Fractional_Input(element.value)
                    } else {
                        elem_value = element.value
                    }

                    let limit = Checklist[CheckKey][0].split(" ")
                    let limit_type = limit[0]
                    let limit_value = parseFloat(limit[1])
                    if ((limit_type == ">" && elem_value > limit_value) || (limit_type == "<" && elem_value < limit_value)) {
                        if (component.classList.contains("hidden")) {
                            component.classList.remove("hidden");
                        }
                    }
                }
            }
        }
    }
    for (component of ShowWhenComponents) {
        if (component.classList.contains("hidden")) {
            Hide_Element(component)
        }
    }


    const HideWhenComponents = document.querySelectorAll('[data-val-hide]');

    //data-val-hide="target=value;"
    for (let component of HideWhenComponents) {
        let Checklist = GetValidationTargets(component.getAttribute('data-val-hide'));
        let AnyValidChecks = false;
        for (let CheckKey of Object.keys(Checklist)) {
            if (document.querySelectorAll('[data-val-key="' + CheckKey + '"],' + '[name="properties[' + CheckKey + ']"]').length != 0) {
                AnyValidChecks = true;
                break
            }
        }
        if (AnyValidChecks) {
            //reveal until validated to be okay
            if (component.classList.contains("hidden")) {
                component.classList.remove("hidden");
            }
            for (let CheckKey of Object.keys(Checklist)) {
                CheckElements = document.querySelectorAll('[data-val-key="' + CheckKey + '"]:checked')

                for (element of CheckElements) {
                    if (Checklist[CheckKey].includes(element.getAttribute('value'))) {
                        Hide_Element(component)
                    }
                }

                InputElements = document.querySelectorAll('[name="properties[' + CheckKey + ']"]')
                for (element of InputElements) {
                    if ((element.getAttribute("type") == "text") || (element.getAttribute("type") == "hidden")) {
                        let elem_value = 0
                        if (element.classList.contains("fraction-enabled")) {
                            elem_value = Convert_Fractional_Input(element.value)
                        } else {
                            elem_value = element.value
                        }
                        let limit = Checklist[CheckKey][0].split(" ")
                        let limit_type = limit[0]
                        let limit_value = parseFloat(limit[1])

                        if ((limit_type == ">" && elem_value > limit_value) || (limit_type == "<" && elem_value < limit_value)) {
                            if (Checklist[CheckKey].includes(element.getAttribute('value'))) {
                                Hide_Element(component)
                            }
                        }
                    }
                }

            }
        }
    }

    for (select of document.querySelectorAll("select")) {
        if (select.selectedOptions[0] == undefined || select.selectedOptions[0].hasAttribute("data-filtered-hidden")) {
            for (option of select.querySelectorAll("option")) {
                if (!option.hasAttribute("data-filtered-hidden")) {
                    select.selectedIndex = option.index
                    select.dispatchEvent(new Event('change'));

                }
            }

        }
    }

    for (elem of document.querySelectorAll("[data-supressed-requirement]")) {
        console.log(elem)
        if (!elem.classList.contains("hidden")) {
            console.log("HIDDEN")
            elem.removeAttribute("data-supressed-requirement")
            elem.setAttribute("required", "")
            let sub_input_list = elem.querySelectorAll('input[type="radio"]')
            for (sub_elem of sub_input_list) {
                sub_elem.setAttribute("required", "")
            }

        }
    }

    let FractionEnabledComponents = document.querySelectorAll('input.fraction-enabled');
    for (elem of FractionEnabledComponents) {
        if (elem.hasAttribute("data-min") && Number(elem.getAttribute("data-min")) > Convert_Fractional_Input(elem.value)) {
            elem.setCustomValidity(`Too Small, Minimum Allowed is ${elem.getAttribute("data-min")} inches`)

        } else if (elem.hasAttribute("data-max") && Number(elem.getAttribute("data-max")) < Convert_Fractional_Input(elem.value)) {
            elem.setCustomValidity(`Too Large, Maximum Allowed is ${elem.getAttribute("data-max")} inches`)

        }

        else {
            elem.setCustomValidity('')
        }
    }



    let CustomValidationComponents = document.querySelectorAll('[data-custom-validation-checks]');
    console.log(CustomValidationComponents)
    for (elem of CustomValidationComponents) {
        console.log(elem)
        CustomValidationChecks(elem)
    }


    Get_Price(UIActive)

}

function Hide_Element(elem) {
    elem.classList.add("hidden")
    let sub_input_list = elem.querySelectorAll('input[type="radio"]')
    for (sub_elem of sub_input_list) {
        if (sub_elem.hasAttribute("required")) {
            sub_elem.removeAttribute("required")
            elem.setAttribute("data-supressed-requirement", "")
        }
        if (sub_elem.checked) {
            console.log(sub_elem)
            sub_elem.checked = false
            sub_elem.dispatchEvent(new Event('change'));
        }
        console.log(sub_elem)
    }
}

function CustomValidationChecks(elem) {
    let checks_list, command_raw, command_processed, validity, variables, command
    validity = ""
    checks_list = elem.getAttribute("data-custom-validation-checks").split("&")
    for (check of checks_list) {
        if (elem.checkValidity()) {
            command_raw = check.trim()
            command_processed = command_raw.match(/(?<command>\w+)\((?<variables>[\w., '\[\]]*)\)/)
            command = command_processed.groups["command"]
            variables = command_processed.groups["variables"].split(",")

            switch (elem.tagName) {

                case "INPUT":

                    elem.setCustomValidity('')
                    switch (command) {
                        case "Check_Numberic_Input":
                            validity = Check_Numberic_Input(...variables)
                            elem.setCustomValidity(validity)
                            break
                        case "Check_Contains":
                            console.log("Check_Contains")
                            validity = Check_If_Input_Contains(...variables)
                            elem.setCustomValidity(validity)
                            break
                    }

                    if (elem.type == "radio") {
                        elem.disabled = false

                        if (validity != "") {
                            elem.disabled = true
                            elem.checked = false
                        }
                    }
                    break

                case "SELECT":

                    elem.setCustomValidity('')
                    switch (command) {
                            
                        case "Check_Contains":
                            console.log("Check_Contains")
                            validity = Check_If_Input_Contains(...variables)
                            if (validity != null){
                                elem.setCustomValidity(validity)
                            }
                            
                            
                            break
                    }


                    if (elem.type == "radio") {
                        elem.disabled = false

                        if (validity != "" && validity != null) {
                            elem.disabled = true
                            elem.checked = false
                        }
                    }
                    break

                default:
                    elem.setCustomValidity('')
                    break
            }

            if (validity != "") {
                break
            }

        }

    }
}
function Prety_Name(raw) {
    formated = raw.replaceAll("'", "")
    formated = formated.replace(/^properties\[/, "")
    formated = formated.replace(/\]$/, "")
    return formated
}

function Check_Numberic_Input(lookup_name, threshold, check_type) {
    let elem, value, condition, return_message

    console.log(threshold)
    is_condition_triggered = false
    elem = document.querySelector(`[name=${lookup_name}]`)

    if (elem.classList.contains("fraction-enabled")) {
        value = Convert_Fractional_Input(elem.value);
    } else {
        value = Number(elem.value)
    }

    pretty_lookup_name = Prety_Name(lookup_name)

    switch (check_type) {
        case "MIN":
            console.log("MIN-confirm")
            is_condition_triggered = value < threshold
            if (is_condition_triggered) {
                return `${pretty_lookup_name} Too Small, Minimum Allowed is ${threshold} inches`
            }
            break

        case "MAX":
            console.log("MAX-confirm")
            is_condition_triggered = value > threshold
            if (is_condition_triggered) {
                return `${pretty_lookup_name} Too Large, Maximum Allowed is ${threshold} inches`

            }
            break

    }

    return ""


}

function Check_If_Input_Contains(lookup_name, check_value, check_type = "Contains") {
    console.log(check_type)
    let elem, value, condition, return_message

    is_condition_triggered = false
    elem = document.querySelector(`[name=${lookup_name}]`)
    if (elem == null){
        console.log(`No ${lookup_name}`)
        return null
    }

    if (elem.tagName == "INPUT"){
        elem_value = elem.value
    }else if (elem.tagName == "SELECT"){
        elem_value = elem.options[elem.selectedIndex].text
    }

    pretty_lookup_name = Prety_Name(lookup_name)
    console.log(elem_value)
    console.log(check_value)
    switch (check_type) {
        case "Contains":
            is_condition_triggered = elem_value.trim().includes(check_value.trim())
            console.log(is_condition_triggered)

            if (is_condition_triggered) {
                return `Not allowed when  ${pretty_lookup_name} is ${check_value}`
            }

            break
    }

    return ""


}

function GetValidationTargets(input) {
    let Result = {};
    let components = input.split(";");
    for (let comp of components) {
        let temp = comp.split("=");
        if (temp.length == 2) {
            Result[temp[0].trim()] = temp[1].split(",").map((x) => x.trim());
        }
    }

    return Result
}

function ShowAllOptions(target) {
    var components = document.querySelectorAll('[data-showall="' + target + '"]');
    for (let component of components) {
        if (component.classList.contains("hidden")) {
            component.classList.remove("hidden");
        }
    }

    var ShowAllOptionsButton = document.getElementById("ShowAllOptions-" + target);
    ShowAllOptionsButton.classList.add("hidden");
}



function ShowInfo(target) {
    setTimeout(() => {
        //console.log(target);
        infobubble = document.getElementById(target);
        infobubble.classList.remove("hidden");
        infobubble.classList.add("visible");
    }, 1000);


}
function HideInfo(target) {
    setTimeout(() => {
        //console.log(target);
        infobubble = document.getElementById(target);
        infobubble.classList.add("hidden");
        infobubble.classList.remove("visible");
    }, 1000);
}

function updateGroupSummary(hiddenname) {
    var checkboxes = document.querySelectorAll('[data-hidden="' + hiddenname + '"]');
    var hiddenfield = document.getElementById(hiddenname);
    var visiblefield = document.getElementById(hiddenname + "-display");
    var displayValue = ""
    let extraProductInfo = ""
    if (hiddenfield != null) {
        var i;
        for (i = 0; i < checkboxes.length; i++) {
            var x = checkboxes[i];
            if (x.checked) {
                if (displayValue == "") {
                    displayValue = x.value;
                    extraProductInfo = x.getAttribute('data-extra-product-info')
                } else {
                    displayValue = displayValue + ", " + x.value;
                    extraProductInfo = extraProductInfo + ", " + x.getAttribute('data-extra-product-info')
                }

            }
        }
    }
    hiddenfield.value = displayValue
    hiddenfield.setAttribute('data-extra-product-info', extraProductInfo)
    if (visiblefield != null) {
        visiblefield.textContent = displayValue;
    };
}

function UpdateImage(InputID) {
    let ControllingElement = document.getElementById(InputID);
    let SelectedDataLink = ControllingElement.options[ControllingElement.selectedIndex].getAttribute('data-datalinkcommand');

    let ImageList = document.querySelectorAll('[data-image-control-input=' + InputID + '] img, [data-image-control-input=' + InputID + '] div');
    //console.log(ImageList)
    let is_found = false
    for (let img_elem of ImageList) {
        if (img_elem.getAttribute('data-datalink') == SelectedDataLink && !is_found) {
            img_elem.classList.remove("hidden");
            is_found = true
        } else if (img_elem.getAttribute('data-datalink') != undefined) {
            img_elem.classList.add("hidden");
        }
    }
}

function FilterOptions(ControllingFormID, ResultSelector, DataFilter) {
    let ControllingElement = document.getElementById(ControllingFormID);
    let ContollingOption = ControllingElement.options[ControllingElement.selectedIndex]
    let SelectedDataLink = ContollingOption.getAttribute(DataFilter);
    let ResultForm = document.querySelector('[name="' + ResultSelector + '"]');

    if (SelectedDataLink == undefined || ResultForm == undefined) {
        return
    }

    let SelectedCheckArray = SelectedDataLink.split(",")
    for (option of ResultForm.children) {
        if (SelectedCheckArray.includes(option.getAttribute("value"))) {
            if (option.classList.contains("hidden")) {
                option.classList.remove("hidden")
            }
            option.removeAttribute("data-filtered-hidden")

        } else {
            option.classList.add("hidden")
            option.setAttribute("data-filtered-hidden", "")

        }

    }
    for (option of ResultForm.nextElementSibling.children) {
        if (SelectedCheckArray.includes(option.getAttribute("value"))) {
            option.removeAttribute("data-filtered-hidden")

        } else {
            option.setAttribute("data-filtered-hidden", "")
        }
    }

    if (ResultForm.selectedOptions[0].classList.contains("hidden")) {
        ResultForm.selectedIndex = ResultForm.querySelector(':not(.hidden)').index
        let event = new Event('change');
        ResultForm.dispatchEvent(event);
    }

    //fix for crown issue
    //special specific cleaner
    let crown = document.querySelector("[name='properties[Crown Type]']")
    if (crown != undefined) {
        crown.dispatchEvent(new Event("change"))
    }



}

function UpdateOptions(ControllingFormID, ResultFormID) {
    let ControllingElement = document.getElementById(ControllingFormID);
    let ContollingOption = ControllingElement.options[ControllingElement.selectedIndex]
    let SelectedDataLink = ContollingOption.getAttribute('data-datalinkcommand');

    let ResultForm = document.getElementById(ResultFormID);
    let VisibleSelect = document.querySelector('[id=' + ResultFormID + ']');
    VisibleSelect.textContent = ""

    let HiddenSelect = VisibleSelect.nextElementSibling;
    let OptionsList = HiddenSelect.children;

    let Index = -1
    let SelectedIndex = 0

    for (let Option of OptionsList) {

        Index += 1
        if (Option.getAttribute('data-datalink') == SelectedDataLink && SelectedIndex == -1) {
            //SelectedIndex = Index
        }

        if (Option.getAttribute('data-datalink') == SelectedDataLink && Option.getAttribute("data-filtered-hidden") == undefined) {
            Option.classList.remove("hidden")

            let clone = Option.cloneNode(true)
            VisibleSelect.appendChild(clone)

        } else if (Option.getAttribute('data-datalink') != SelectedDataLink && Option.getAttribute('data-datalink') != undefined) {

        }
    }

    //VisibleSelect.selectedIndex = 0

    let event = new Event('change');
    ResultForm.dispatchEvent(event);

}

function Calculate_Form_Fields() {
    const Calculate_Fields = document.querySelectorAll('[data-calculated]');

    for (elem of Calculate_Fields) {
        let start = elem.getAttribute("data-calculated-start")
        let add_keys = elem.getAttribute("data-calculated-add").split(",")
        let subtract_keys = elem.getAttribute("data-calculated-subtract").split(",")

        let calculated_value = parseFloat(start)
        for (key of add_keys) {
            add_elem = document.querySelector('[name="properties[' + key + ']"]')
            if (add_elem != undefined) {
                calculated_value += Convert_Fractional_Input(add_elem.value)
            }
        }

        for (key of subtract_keys) {
            subtract_elem = document.querySelector('[name="properties[' + key + ']"]')
            if (subtract_elem != undefined) {
                calculated_value -= Convert_Fractional_Input(subtract_elem.value)
            }

        }
        elem.value = calculated_value
    }
}

function Filter_Select(container_element, driving_select_class, driving_key_attribute, dependent_select_class) {
    let keys = container_element.querySelector(`.${driving_select_class}`).selectedOptions[0].getAttribute(driving_key_attribute).split(",");
    let dependent_select_elem = container_element.querySelector(`.${dependent_select_class}`)
    const selected_value = dependent_select_elem.value
    Show_Only_Matching_Keys(keys, dependent_select_elem);

    dependent_select_elem.selectedIndex = 0
    Select_Value(dependent_select_elem, selected_value)

}

function Select_Value(elem, target_value) {
    for (op of elem.options) {

        if (op.value == target_value || op.textContent == target_value) {
            elem.selectedIndex = op.index
            //elem.dispatchEvent(new Event('change'))
            break
        }

    }
}


function Show_Only_Matching_Keys(allowed_keys, parent_scope) {
    let all_query = `[data-key-tag]`;

    let all_elements = parent_scope.querySelectorAll(all_query)
    for (elem of all_elements) {
        elem.remove()
    }

    for (elem of parent_scope.parentElement.querySelector(".holding-pen").querySelectorAll(all_query)) {
        if (allowed_keys.includes(elem.getAttribute("data-key-tag"))) {
            parent_scope.appendChild(elem.cloneNode(true));

        }
    }
}

function Find_Container_Parent(elem, target_class) {
    while (elem.parentElement != undefined && elem.classList.contains(target_class) == false) {
        elem = elem.parentElement
    }

    return elem
}



function Handle_Door_Change(event) {
    container = Find_Container_Parent(event.target, "style-item")
}

function Handle_Material_Change(event) {
    container = Find_Container_Parent(event.target, "style-item")
}

function Disable_Events() {
    document.addEventListener("click", Disable_Events_Handler, true);
    document.addEventListener("select", Disable_Events_Handler, true);
    document.addEventListener("scroll", Disable_Events_Handler, true);

}
function Enable_Events() {
    document.removeEventListener("click", Disable_Events_Handler, true);
    document.removeEventListener("select", Disable_Events_Handler, true);
    document.removeEventListener("scroll", Disable_Events_Handler, true);
}

function Disable_Events_Handler(event) {
    if ((event.target != undefined && event.target.classList != undefined && event.target.classList.contains("freezable")) || event.type == "scroll") {
        event.stopPropagation();
        event.preventDefault();
    }
}